import React, { useState } from "react";
import "./Login.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEyeSlash,
  faLock,
  faUser,
  faLeaf,
} from "@fortawesome/free-solid-svg-icons";
import { Controller, useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import YellowBtn from "../../common/common_btn/yellow_btn/Yellow_Btn";
import { useNavigate } from "react-router-dom";

const LOGO_SRC = "/assets/images/Ayurlife(1).webp";

const Login = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      rememberMe: true,
    },
  });

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  // Navigate only after react-hook-form validation passes.
  const onSubmit = () => {
    navigate("/dashboard");
  };

  return (
    <section className="Login">
      <div className="login_shell">
        {/* Brand panel (desktop / tablet landscape) */}
        <aside className="login_brand" aria-hidden="true">
          <div className="login_brand_logo">
            <img src={LOGO_SRC} alt="" className="left_logo" />
          </div>
          <h2 className="login_brand_title">AyurLife Member Panel</h2>
          <p className="login_brand_text">
            Manage your team, orders, wallet and income in one place.
          </p>
          <span className="login_brand_leaf">
            <FontAwesomeIcon icon={faLeaf} />
          </span>
        </aside>

        {/* Form panel */}
        <div className="login-card">
          <div className="inner_div">
            <img src={LOGO_SRC} alt="AyurLife" className="login_mobile_logo" />

            <h1 className="title">Welcome Back!</h1>
            <p className="subtitle">Enter your Login details below</p>

            <Form noValidate onSubmit={handleSubmit(onSubmit)}>
              {/* Username Input */}
              <div className="form-group">
                <label htmlFor="login-username" className="login_label">
                  Username
                </label>
                <div className="input-container">
                  <span className="icon-wrapper user-icon">
                    <FontAwesomeIcon icon={faUser} />
                  </span>
                  <Controller
                    name="username"
                    control={control}
                    rules={{ required: "Username is required" }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        id="login-username"
                        type="text"
                        autoComplete="username"
                        placeholder="Enter Username"
                        isInvalid={!!errors.username}
                        className="custom-bootstrap-input"
                      />
                    )}
                  />
                </div>
                {errors?.username && (
                  <span className="error-text" role="alert">
                    {errors.username.message}
                  </span>
                )}
              </div>

              {/* Password Input */}
              <div className="form-group">
                <label htmlFor="login-password" className="login_label">
                  Password
                </label>
                <div className="input-container">
                  <span className="icon-wrapper lock-icon">
                    <FontAwesomeIcon icon={faLock} />
                  </span>
                  <Controller
                    name="password"
                    control={control}
                    rules={{ required: "Password is required" }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        id="login-password"
                        type={showPassword ? "text" : "password"}
                        autoComplete="current-password"
                        placeholder="Enter Password"
                        isInvalid={!!errors.password}
                        className="custom-bootstrap-input has-toggle"
                      />
                    )}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword((prev) => !prev)}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
                {errors?.password && (
                  <span className="error-text" role="alert">
                    {errors.password.message}
                  </span>
                )}
              </div>

              {/* Remember Me Checkbox */}
              <div className="remember-section">
                <Controller
                  name="rememberMe"
                  control={control}
                  render={({ field: { value, onChange, ref, ...field } }) => (
                    <Form.Check
                      {...field}
                      type="checkbox"
                      id="rememberMe"
                      label="Remember me"
                      checked={value}
                      onChange={(e) => onChange(e.target.checked)}
                      className="custom-bootstrap-checkbox"
                    />
                  )}
                />
                <p className="subtext">Keep me signed in on this device.</p>
              </div>

              {/* Submit Button */}
              <YellowBtn btnText="Login Now" type="submit" />
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
